import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
// @ts-expect-error untyped
import formatCurrencyCode from 'I18n/utils/formatCurrencyCode';
import { formatIntlCurrency } from 'I18n/utils/formatIntlCurrency';
import { Table } from 'foundations-components/transitional/components/Table';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Modal } from 'foundations-components/transitional/components/Modal';
import styled from 'styled-components';
import getPropertyValue from '../../../dataAccessHelpers/getPropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RightAlignedTH = styled.th.withConfig({
  displayName: "FeesModal__RightAlignedTH",
  componentId: "ih5i86-0"
})(["text-align:right !important;"]);
const FeesModal = ({
  transactionFees,
  paymentMethodType,
  properties,
  onClose
}) => {
  const settlementCurrencyCode = getPropertyValue(properties, 'hs_settlement_currency_code');
  const currencyCode = getPropertyValue(properties, 'hs_currency_code');
  const initialAmount = getPropertyValue(properties, 'hs_initial_amount');
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "fees-modal",
    width: "600px",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "fees-dialog-close-btn",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h6",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.description",
          options: {
            amount: formatIntlCurrency(Number(initialAmount || 0), {
              currencyCode
            })
          }
        })
      }), transactionFees.processingFees.length > 0 && /*#__PURE__*/_jsxs(Table, {
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.processingFees"
              })
            }), /*#__PURE__*/_jsx(RightAlignedTH, {
              align: "right",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.rate"
              })
            }), /*#__PURE__*/_jsx(RightAlignedTH, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.feeAmount"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: transactionFees.processingFees.map(fee => /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(Text, {
                as: "h6",
                children: fee.type === 'PAYMENT_METHOD_FEE' ? /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.feeTypes.${fee.type}.${paymentMethodType}`
                }) : /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.feeTypes.${fee.type}`
                })
              })
            }), /*#__PURE__*/_jsxs("td", {
              align: "right",
              children: [/*#__PURE__*/_jsx(FormattedPercentage, {
                value: fee.rate * 100,
                precision: 2
              }), fee.maxFee && /*#__PURE__*/_jsxs(_Fragment, {
                children: [' ', /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.maximumFee",
                  options: {
                    maximumAmount: formatIntlCurrency(fee.maxFee, {
                      currencyCode: fee.currencyCode
                    })
                  }
                })]
              })]
            }), /*#__PURE__*/_jsx("td", {
              align: "right",
              children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
                value: fee.amount,
                currencyCode: fee.currencyCode
              })
            })]
          }, fee.type))
        })]
      }), transactionFees.platformFees.length > 0 && /*#__PURE__*/_jsxs(Table, {
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(HelpIcon, {
                tooltipProps: {
                  use: 'longform'
                },
                title: /*#__PURE__*/_jsxs(List, {
                  styled: true,
                  ordered: false,
                  padding: "200",
                  children: [/*#__PURE__*/_jsx(ListItem, {
                    marginBlockEnd: "100",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.platformFeeTooltip.platformFeeExplanation"
                    })
                  }), /*#__PURE__*/_jsx(ListItem, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.platformFeeTooltip.platformFeeInclusions"
                    })
                  })]
                }),
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.platformFee"
                })
              })
            }), /*#__PURE__*/_jsx(RightAlignedTH, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.rate"
              })
            }), /*#__PURE__*/_jsx(RightAlignedTH, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.feeAmount"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: transactionFees.platformFees.map(fee => /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(Text, {
                as: "h6",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.feeTypes.${fee.type}`
                })
              })
            }), /*#__PURE__*/_jsxs("td", {
              align: "right",
              children: [/*#__PURE__*/_jsx(FormattedPercentage, {
                value: fee.rate * 100,
                precision: 2
              }), fee.maxFee && /*#__PURE__*/_jsxs(_Fragment, {
                children: [' ', /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.maximumFee",
                  options: {
                    maximumAmount: formatIntlCurrency(fee.maxFee, {
                      currencyCode: fee.currencyCode
                    })
                  }
                })]
              })]
            }), /*#__PURE__*/_jsx("td", {
              align: "right",
              children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
                value: fee.amount,
                currencyCode: fee.currencyCode
              })
            })]
          }, fee.type))
        })]
      }), settlementCurrencyCode !== currencyCode && /*#__PURE__*/_jsx(Text, {
        as: "small",
        marginBlockStart: "400",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.feesDisplayedInSettlementCurrency",
          options: {
            settlementCurrency: formatCurrencyCode(settlementCurrencyCode)
          }
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onClose,
        "data-test-id": "fees-close-btn",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.fees.modal.closeButtonText"
        })
      })
    })]
  });
};
export default FeesModal;